import React from "react";
import styles from './footerpublic.module.css';
import { Link as Linkto } from "react-router-dom";
import { Link, Events, animateScroll as scroll, scroller } from 'react-scroll'

function Footer() {
  return (
    <footer className={`${styles.Footer}`}>
      <div className={`${styles.Container}`}>
        <div className={`${styles.FooterTop}`}>
          <div className={`${styles.FooterBrand}`}>
            <img src="/static/img/logo.svg" alt="PropertyDek" height="30" className={`${styles.FooterLogo}`} />
            <p>Affordable &amp; workforce housing operations, simplified. Built for teams under 1,000 doors.</p>
            {/* <div className={`${styles.FooterSocial}`}>
              <Linkto href="" aria-label="LinkedIn">
                <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"></path><circle cx="4" cy="4" r="2"></circle></svg>
              </Linkto>
              <Linkto href="" aria-label="Twitter">
                <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>
              </Linkto>
            </div> */}
          </div>
          <div className={`${styles.FooterLinks}`}>
            <div>
              <a className={`${styles.FootListLinkBig}`} href="tel:17188254746">1-718-825-4746</a>
              <a className={`${styles.FootListLinkBig}`} href="mailto:hello@propertydek.com">hello@propertydek.com</a>
              <div className={`${styles.AppstoreSec}`}>
                <a href="https://play.google.com/store/apps/details?id=com.propertydek.ionicapp" target="_blank"><img src="/static/img/play-store.png" alt="PropertyDek-play-store" /></a>
                <a href="https://apps.apple.com/app/PropertyDek/id1661119081" target="_blank"><img src="/static/img/app-store.png" alt="PropertyDek-app-store" /></a>
              </div>
            </div>
          </div>
        </div>
        <div className={`${styles.FooterBottom}`}>
          <p>© 2026 PropertyDek. All rights reserved.</p>
          <div className={`${styles.FooterLegal}`}>
            <Linkto to={'/privacy-policy'} target="_blank">Privacy Policy</Linkto>
            <Linkto to={'/eula'} target="_blank">End User License Agreement</Linkto>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
